import { render, staticRenderFns } from "./InheritanceTax.vue?vue&type=template&id=161bf264&scoped=true&"
import script from "./InheritanceTax.vue?vue&type=script&lang=js&"
export * from "./InheritanceTax.vue?vue&type=script&lang=js&"
import style0 from "./InheritanceTax.vue?vue&type=style&index=0&id=161bf264&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "161bf264",
  null
  
)

export default component.exports